import Vue from 'vue'
import VueRouter from 'vue-router'
import useJwt from "@/auth/jwt/useJwt";

Vue.use(VueRouter)
// router page
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'Dashboard',
        // breadcrumb: [
        //   {
        //     text: 'Home',
        //     active: true,
        //   },
        // ],
      },
    },
    {
      path: '/employee-master',
      name: 'employee-master',
      component: () => import('@/views/MasterEmployee.vue'),
      meta: {
        pageTitle: 'Master Karyawan',
        breadcrumb: [
          {
            text: 'Master Karyawan',
            active: true,
          },
        ],
      },
    },
    {
      path: '/employee-master/:id',
      name: 'employee-master.show',
      component: () => import('@/views/DetailEmployee.vue'),
      meta: {
        auth: true,
        pageTitle: 'Detail Karyawan',
        breadcrumb: [{
          text: 'Karyawan',
          active: true,
        },
        {
          text: 'Detail',
          active: true,
        },
        ],
        navActiveLink: 'employee-master',
      },
    },
    {
      path: '/announcement',
      name: 'announcement',
      component: () => import('@/views/Announcement.vue'),
      meta: {
        auth: true,
        pageTitle: 'Pengumuman',
      },
    },
    {
      path: '/attendance',
      name: 'attendance',
      component: () => import('@/views/Attendance.vue'),
      meta: {
        pageTitle: 'Absen',
        breadcrumb: [
          {
            text: 'Absen',
            active: true,
          },
        ],
      },
    },
    {
      path: '/attendace/:id',
      name: 'attendance.show',
      component: () => import('@/views/AttendanceDetail.vue'),
      meta: {
        auth: true,
        pageTitle: 'Detail Absensi',
        breadcrumb: [
          {
            text: 'Absen',
            active: false,
          },
          {
            text: 'detail Absen',
            active: true,
          },
        ]
      }
    },
    {
      path: '/overtime',
      name: 'overtime',
      component: () => import('@/views/Overtime.vue'),
      meta: {
        pageTitle: 'Lembur',
        breadcrumb: [
          {
            text: 'Lembur',
            active: true,
          },
        ],
      },
    },
    {
      path: '/leave',
      name: 'leave',
      component: () => import('@/views/PermissionAndLeave.vue'),
      meta: {
        pageTitle: 'Izin dan Sakit',
        breadcrumb: [
          {
            text: 'Izin dan Sakit',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sppd',
      name: 'sppd',
      component: () => import('@/views/Sppd.vue'),
      meta: {
        pageTitle: 'SPPD',
        breadcrumb: [
          {
            text: 'SPPD',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reimburse',
      name: 'reimburse',
      component: () => import('@/views/Reimburse.vue'),
      meta: {
        pageTitle: 'Reimburse',
        breadcrumb: [
          {
            text: 'Reimburse',
            active: true,
          },
        ],
      },
    },
    {
      path: '/branch-master',
      name: 'branch',
      component: () => import('@/views/OrganizationalSetting/MasterBranch.vue'),
      meta: {
        pageTitle: 'Master Cabang',
        breadcrumb: [
          {
            text: 'Master Cabang',
            active: true,
          },
        ],
      },
    },
    {
      path: '/department-master',
      name: 'department',
      component: () => import('@/views/OrganizationalSetting/MasterDepartment.vue'),
      meta: {
        pageTitle: 'Master Departemen',
        breadcrumb: [
          {
            text: 'Master Departemen',
            active: true,
          },
        ],
      },
    },

    {
      path: '/band-master',
      name: 'band',
      component: () => import('@/views/OrganizationalSetting/MasterBand.vue'),
      meta: {
        pageTitle: 'Master Band',
        breadcrumb: [
          {
            text: 'Master Band',
            active: true,
          },
        ],
      },
    },
    {
      path: '/grade-master',
      name: 'grade',
      component: () => import('@/views/OrganizationalSetting/MasterGrade.vue'),
      meta: {
        pageTitle: 'Master Grade',
        breadcrumb: [
          {
            text: 'Master Grade',
            active: true,
          },
        ],
      },
    },
    {
      path: '/job-title-master',
      name: 'jobtittle',
      component: () => import('@/views/OrganizationalSetting/MasterJobTitle.vue'),
      meta: {
        pageTitle: 'Master Job Title',
        breadcrumb: [
          {
            text: 'Master Job Title',
            active: true,
          },
        ],
      },
    },
    {
      path: '/employee-shift',
      name: 'shift',
      component: () => import('@/views/AttendanceSetting/EmployeeShift.vue'),
      meta: {
        pageTitle: 'Shift Karyawan',
        breadcrumb: [
          {
            text: 'Shift Karyawan',
            active: true,
          },
        ],
      },
    },
    {
      path: '/employee-shift/:id',
      name: 'employee-shift.show',
      component: () => import('@/views/DetailShift.vue'),
      meta: {
        auth: true,
        pageTitle: 'Detail Shift Karyawan',
        breadcrumb: [
        {
          text: 'Detail',
          active: true,
        },
        ],
        navActiveLink: 'employeee-shift',
      },
    },
    {
      path: '/global-holiday',
      name: 'holidays',
      component: () => import('@/views/AttendanceSetting/GlobalHoliday.vue'),
      meta: {
        pageTitle: 'Global Holiday',
        breadcrumb: [
          {
            text: 'Global Holiday',
            active: true,
          },
        ],
      },
    },
    {
      path: '/master-leave',
      name: 'leave-master',
      component: () => import('@/views/AttendanceSetting/MasterLeave.vue'),
      meta: {
        pageTitle: 'Master Cuti',
        breadcrumb: [
          {
            text: 'Master Cuti',
            active: true,
          },
        ],
      },
    },
    {
      path: '/master-leave/:id/employee-leave-quota',
      name: 'employee-leave-quota',
      component: () => import('@/views/AttendanceSetting/EmployeeLeaveQuota.vue'),
      meta: {
        pageTitle: 'Kuota Cuti Karyawan',
      },
    },
    {
      path: '/quota-reimburse/:id',
      name: 'quota-reimburse-employee',
      component: () => import('@/views/QuotaReimburseEmployee'),
      meta: {
        auth: true,
        pageTitle: 'Kuota Reimburse Karyawan',
      }
    },
    {
      path: '/master-region',
      name: 'region',
      component: () => import('@/views/SystemSetting/MasterRegion.vue'),
      meta: {
        pageTitle: 'Master Region',
        breadcrumb: [
          {
            text: 'Master Region',
            active: true,
          },
        ],
      },
    },
    {
      path: '/master-parameter-system',
      name: 'param-system',
      component: () => import('@/views/SystemSetting/MasterParameterSystem.vue'),
      meta: {
        pageTitle: 'Master Param System',
        breadcrumb: [
          {
            text: 'Master Param System',
            active: true,
          },
        ],
      },
    },
    {
      path: '/master-parameter-list',
      name: 'param-list',
      component: () => import('@/views/SystemSetting/MasterParameterList.vue'),
      meta: {
        pageTitle: 'Master Param List',
        breadcrumb: [
          {
            text: 'Master Param List',
            active: true,
          },
        ],
      },
    },
    {
      path: '/master-flow-approval',
      name: 'flow-master',
      component: () => import('@/views/SystemSetting/MasterFlowApproval.vue'),
      meta: {
        pageTitle: 'Master Flow Approval',
        breadcrumb: [
          {
            text: 'Master Flow Approval',
            active: true,
          },
        ],
      },
    },
    {
      path: '/master-flow-approval/:id',
      name: 'flow-master.show',
      component: () => import('@/views/DetailFlowApproval.vue'),
      meta: {
        auth: true,
        pageTitle: 'Detail Flow Approval',
        breadcrumb: [{
          text: 'Flow Approval',
          active: true,
        },
        {
          text: 'Detail',
          active: true,
        },
        ],
        navActiveLink: 'master-flow-approval',
      },
    },
    {
      path: '/standart-salary',
      name: 'standart-salary',
      component: () => import('../views/ConfigurationSalary/StandartSalary'),
      meta: {
        auth: true,
        pageTitle: 'Configuration Salary',
        breadcrumb: [
          {
            text: 'Configuration Salary',
            active: true
          }
        ]
      }
    },
    {
      path: '/standart-salary/add',
      name: 'standart-salary-add',
      component: () => import('../views/ConfigurationSalary/StandartSalaryForm'),
      meta: {
        auth: true,
        pageTitle: 'Add Salary',
        breadcrumb: [
          {
            text: 'Configuration Salary',
            active: false
          },
          {
            text: 'Add Salary',
            active: true
          }
        ]
      }
    },
    {
      path: '/standart-salary/update/:id',
      name: 'standart-salary-update',
      component: () => import('../views/ConfigurationSalary/StandartSalaryForm'),
      meta: {
        auth: true,
        pageTitle: 'Update Salary',
        breadcrumb: [
          {
            text: 'Configuration Salary',
            active: false
          },
          {
            text: 'Update Salary',
            active: true
          }
        ]
      }
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/Profile'),
      meta: {
        auth: true,
        pageTitle: 'Profile',
        breadcrumb:  [
          {
            text: 'Profile',
            active: true
          }
        ]
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/user-management',
      name: 'user-admin',
      component: () => import('@/views/UserAdmin.vue'),
      meta: {
        auth: true,
        pageTitle: 'User Admin',
        breadcrumb:  [
          {
            text: 'User Admin',
            active: true
          }
        ]
      }
    },
    {
      path: '/employee-management',
      name: 'user-employee',
      component: () => import('@/views/UserEmployee.vue'),
      meta: {
        auth: true,
        pageTitle: 'User Karyawan',
        breadcrumb:  [
          {
            text: 'User Karyawan',
            active: true
          }
        ]
      }
    },
    {
      path: '/role-management',
      name: 'role',
      component: () => import('@/views/Role'),
      meta: {
        auth: true,
        pageTitle: 'Role',
        breadcrumb:  [
          {
            text: 'Role',
            active: true
          }
        ]
      }
    },
    {
      path: '/loan-employee',
      name: 'loan-employee',
      component: () => import('@/views/Loan'),
      meta: {
        auth: true,
        pageTitle: 'Pembiayaan Karyawan',
      }
    },
    {
      path: '/employee-movement-submit',
      name: 'employee-movement-submit',
      component: () => import('@/views/EmployeeMovement'),
      meta: {
        auth: true,
        pageTitle: 'Pengajuan Mutasi Karyawan',
      }
    },
    {
      path: '/employee-movement-approval',
      name: 'employee-movement-approval',
      component: () => import('@/views/EmployeeMovementApproval'),
      meta: {
        auth: true,
        pageTitle: 'Approval Mutasi Karyawan',
      }
    },
    {
      path: '/quota-reimburse',
      name: 'quota-reimburse',
      component: () => import('@/views/QuotaReimburse'),
      meta: {
        auth: true,
        pageTitle: 'Periode Quota Reimburse',
      }
    },
    {
      path: '/quota-reimburse',
      name: 'quota-reimburse',
      component: () => import('@/views/QuotaReimburse'),
      meta: {
        auth: true,
        pageTitle: 'Periode Quota Reimburse',
      }
    },
    {
      path: '/quota-reimburse/:id',
      name: 'quota-reimburse-employee',
      component: () => import('@/views/QuotaReimburseEmployee'),
      meta: {
        auth: true,
        pageTitle: 'Kuota Reimburse Karyawan',
      }
    },
    {
      path: '/master/transport',
      name: 'master-transport',
      component: () => import('@/views/MasterTransport/MasterTransport'),
      meta: {
        auth: true,
        pageTitle: 'Master Tunjangan Makan dan Transport'
      }
    },
    {
      path: '/master/basic-salary',
      name: 'master-basic-salary',
      component: () => import('@/views/MasterBasicSalary/MasterBasicSalary'),
      meta: {
        auth: true,
        pageTitle: 'Master Gaji Pokok'
      }
    },
    {
      path: '/master/master-manual-salary',
      name: 'master-manual-salary',
      component: () => import('@/views/MasterManualSalary/MasterManualSalary.vue'),
      meta: {
        auth: true,
        pageTitle: 'Master Manual Salary'
      }
    },
    {
      path: '/calculate-salary',
      name: 'calculate-salary',
      component: () => import('@/views/Payroll/CalculateSalary.vue'),
      meta: {
        auth: true,
        pageTitle: 'Hitung Gaji'
      }
    },
    {
      path: '/calculate-salary/view/:id',
      name: 'calculate-salary-view',
      component: () => import("@/views/Payroll/CalculateSalaryView.vue"),
      meta: {
        auth: true,
        pageTitle: 'Hitung Gaji'
      }
    },
    {
      path: '/component-salary',
      name: 'component-salary',
      component: () => import('@/views/MasterComponentSalary/MasterComponentSalary.vue'),
      meta: {
        auth: true,
        pageTitle: 'Master Komponen Gaji'
      }
    },
    {
      path: '/component-salary/:status/:id',
      name: 'component-salary-form',
      component: () => import('@/views/MasterComponentSalary/MasterComponentSalaryForm.vue'),
      meta: {
        auth: true,
        pageTitle: 'Component Salary Form'
      }
    },
    {
      path: '/approval-payroll',
      name: 'approval-payroll',
      component: () => import("@/views/ApprovalReleaseSalary/ApprovalReleaseSalary.vue"),
      meta: {
        auth: true,
        pageTitle: 'Approval Rilis Gaji'
      }
    },
    {
      path: '/approval-fix-employee',
      name: 'approval-fix-employee',
      component: () => import("@/views/PermanentEmployee/PermanentEmployee.vue"),
      meta: {
        auth: true,
        pageTitle: 'Daftar Calon Karyawan Tetap'
      }
    },
    {
      path: '/approval-kpi-allowance',
      name: 'approval-kpi-allowance',
      component: () => import('@/views/PerformanceAllowance/PerformanceAllowance.vue'),
      meta: {
        auth: true,
        pageTitle: 'Penetapan Tunjangan Kinerja'
      }
    },
    {
      path: '/approval-kpi-allowance/view/:id',
      name: 'ApprovalAllowanceView',
      component: () => import("@/views/PerformanceAllowance/PerformanceAllowanceView.vue"),
      meta: {
        auth: true,
        pageTitle: 'Penetapan Tunjangan Kinerja'
      }
    },
    {
      path: '/approval-payroll/view/:id',
      name: 'viewApprovalPayroll',
      component: () => import("@/views/ApprovalReleaseSalary/ApprovalReleaseSalaryView.vue"),
      meta: {
        auth: true,
        pageTitle: 'Approval Rilis Gaji'
      }
    },
    {
      path: '/structure-salary',
      name: 'structure-salary',
      component: () => import('@/views/MasterSalaryStructure/MasterSalaryStructure.vue'),
      meta: {
        auth: true,
        pageTitle: 'Master Struktur Gaji'
      }
    },
    {
      path: '/structure-salary/:status/:id',
      name: "StructureSalaryForm",
      component: () => import("@/views/MasterSalaryStructure/MasterSalaryStructureForm.vue"),
      meta: {
        auth: true,
        pageTitle: "Master Struktur Gaji"
      }
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  let token = useJwt.getToken();
  if (token === null) {
    router.push('/login');
  }
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
